export default "__VITE_ASSET__DJRNHZg$__"